import React from 'react'
import moment from 'moment'
import min from 'lodash/min'
import map from 'lodash/map'
import { FlexDatesCollapsableOw } from './FlexDatesCollapsableOw/FlexDatesCollapsableOw'
import { fireFlyConditions } from '../../constants/fireflyCondition'

export const getFlexDates = ({
  minRetailPrice,
  minRetailStops,
  calendarPricing,
  travelDate,
  tripType,
  searchOrigin,
  searchDestination,
  expressDealInfo = {}
}) => {
  const origDepartDate = moment(travelDate).startOf('day')
  const today = moment().startOf('day')
  const currencySymbol = '$' // ToDo: Update currencySymbol based on User Selected Currency
  let isflexDatesAvailable = false
  /**
   * Get the origin, destination, cabinClass and passengerURl from the first available calendar Pricing Object
   * These parameters are consistent across all calendarPricing Objects
   */
  const flexDatesDetails = calendarPricing.find(flexDate => {
    return flexDate?.destination1 && flexDate?.origin1
  })

  /**
   * If none of the calendarPricing Object return Origin and Destination, return null.
   * This is a rare case scenario.
   */
  if (!flexDatesDetails) {
    return null
  }

  // Get the days difference between Travel(Depart) Date and Current Day(today)
  const dateDiff = origDepartDate.diff(today, 'd')

  /**
   * create an array of -/+ 1 or 2 days from travel date(origDepartDate)
   * flexDatesRange contains list of dates
   */
  const flexDatesRange = []

  const daysAfterSelectedDate =
    tripType === 'OW' && dateDiff === 0 ? 3 : 2
  const daysBeforeSelectedDate =
    dateDiff >= daysAfterSelectedDate
      ? -1 * daysAfterSelectedDate
      : -1 * dateDiff

  const startDate = moment(travelDate).add(daysBeforeSelectedDate, 'days')
  const endDate = moment(travelDate).add(daysAfterSelectedDate, 'days')

  /**
   * Create an Array of Date Objects ranging from startDate to endDate
   */
  while (startDate.isSameOrBefore(endDate)) {
    flexDatesRange.push(startDate.clone())
    startDate.add(1, 'days')
  }

  const expressDeal = expressDealInfo.searchedDate
  const expressDealFlexDates = expressDealInfo.flexDates

  let lastCabinClass
  const flexDatesMap = flexDatesRange.map(flexDatesRangeNode => {
    let cabinClass = flexDatesDetails.cabinClass || 'ECO'
    lastCabinClass = cabinClass
    let flexDatePrice
    let flexDatePriceExists = false
    let isOriginalDepartDate = false
    let flexDateSearchUrl = ''
    let numStops
    let passengerUrl = flexDatesDetails.passengerUrl || ''
    const formatDepartDateUrl = moment(flexDatesRangeNode).format('YYYYMMDD')
    const flexDateDaysDiff = flexDatesRangeNode.diff(origDepartDate, 'd')
    if (flexDateDaysDiff === 0) {
      flexDatePrice = Math.ceil(minRetailPrice)
      flexDatePriceExists = !!minRetailPrice
      isOriginalDepartDate = true
      numStops = minRetailStops

      if (
        expressDeal &&
        expressDeal.pricingInfo &&
        expressDeal.pricingInfo.totalFare < minRetailPrice
      ) {
        numStops = 7
        flexDatePrice = Math.ceil(expressDeal.pricingInfo.totalFare)
      }
    } else {
      /**
       * Check for calendarPricingObject corresponding to flexDatesRangeNode.
       */
      const altDateObj = calendarPricing.find(
        calendarPricingNode =>
          calendarPricingNode.departDate ===
          moment(flexDatesRangeNode).format('YYYY-MM-DD')
      )

      const getExpressDealFlexDates = (expressDealFlexDates, altDateObj) => {
        return expressDealFlexDates.find(expressDealFlexDate => {
          return (
            expressDealFlexDate.departDate === altDateObj.departDate &&
            expressDealFlexDate.returnDate === altDateObj.returnDate &&
            expressDealFlexDate.fare < altDateObj.fare
          )
        })
      }

      if (altDateObj) {
        /* If flexDatesAvailable is true then the Carousel component is displayed */
        if (!isflexDatesAvailable && !fireFlyConditions.isFireFly()) {
          isflexDatesAvailable = true
        }
        cabinClass = altDateObj.cabinClass
        flexDatePrice = Math.ceil(altDateObj.fare)
        flexDatePriceExists = true
        passengerUrl = altDateObj.passengerUrl
        numStops = altDateObj.numStops

        if (expressDealFlexDates) {
          const expressDealFlexDate = getExpressDealFlexDates(
            expressDealFlexDates,
            altDateObj
          )
          if (expressDealFlexDate) {
            numStops = 7
            flexDatePrice = Math.ceil(expressDealFlexDate.fare)
          }
        }
      } else {
        cabinClass = cabinClass || lastCabinClass
      }

      const getSearchURL = ({
        searchOrigin,
        searchDestination,
        formatDepartDateUrl,
        cabinClass,
        passengerUrl,
      }) => {
        const sliceUrl = `${searchOrigin}-${searchDestination}-${formatDepartDateUrl}/`
        return `/m/fly/search/${sliceUrl}?cabin-class=${cabinClass}&${passengerUrl}`
      }

      flexDateSearchUrl = getSearchURL({
        searchOrigin,
        searchDestination,
        formatDepartDateUrl,
        cabinClass,
        passengerUrl,
      })
    }
    return {
      flexDatePrice,
      formatDepartDateUrl,
      minRetailPrice,
      flexDate: moment(flexDatesRangeNode).format('ddd, MMM D'),
      flexDatePriceExists,
      isOriginalDepartDate,
      currencySymbol,
      flexDateDaysDiff,
      flexDateSearchUrl,
      numStops,
      tripType,
    }
  })

  const lowestPrice = min(map(flexDatesMap, 'flexDatePrice'))

  const lowestPriceDates = flexDatesMap.filter(({ flexDatePrice }) => {
    return flexDatePrice === lowestPrice
  })

  if (lowestPriceDates.length === 1) {
    lowestPriceDates[0].hasLowestPrice = true
  }


  if (!isflexDatesAvailable) {
    return null
    }
    return (
      <FlexDatesCollapsableOw
        flexDates={flexDatesMap}
        searchDestination={searchDestination}
      />
    )

}